import { Component, input } from '@angular/core';
import { UserTextBubble } from './components/user-text-bubble';
import { BotTextBubble } from './components/bot-text-bubble';
import { Message } from '../../services/chat-service/types';

@Component({
  selector: 'chat-exchange',
  templateUrl: './chat-exchange.html',
  styleUrl: './chat-exchange.scss',
  imports: [UserTextBubble, BotTextBubble],
})
export class ChatExchange {
  readonly messages = input.required<Message[]>();
  readonly chatId = input.required<string>();
}
